import { render, staticRenderFns } from "./MobileCalendar.vue?vue&type=template&id=64ea8536&scoped=true"
import script from "./MobileCalendar.vue?vue&type=script&lang=js"
export * from "./MobileCalendar.vue?vue&type=script&lang=js"
import style0 from "./MobileCalendar.vue?vue&type=style&index=0&id=64ea8536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea8536",
  null
  
)

export default component.exports